import React, { useEffect, useState } from "react";

import { useParams } from "react-router-dom";

import MenuTabsWithLink from "../../../components/common/MenuTabs";
import Image from "../../../components/elements/Image";

import Comment from "../comment/Comment";
import { taskDetails } from "../../../services/taskService";
import PostContent from "../Post/PostContent";
import { categoryList } from "../../../services/catagoryService";

export default function TaskDetails() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [categories, setCategories] = useState([]);
  const [categoryNames, setCategoryNames] = useState([]);
  useEffect(() => {
    async function fetchData() {
      const res = await taskDetails(id);
      setData(res?.data);
    }
    fetchData();
  }, [id]);
  useEffect(() => {
    async function fetchCategories() {
      const res = await categoryList();
      if (res?.docs?.success && res?.docs?.data) {
        // console.log(res?.docs?.data, "data");

        setCategories(res?.docs?.data);
      }
      // console.log(categories);
    }
    fetchCategories();
  }, []);

  useEffect(() => {
    if (data?.categoryIds?.length && categories.length) {
      const matched = categories
        .filter((cat) => data.categoryIds.includes(cat._id))
        .map((cat) => cat.name);
      setCategoryNames(matched);
      // const matched = categories
      //   .filter((cat) => {
      //     const match = data.categoryIds.includes(cat._id);
      //     console.log(`Checking: ${cat._id} => match: ${match}`);
      //     return match;
      //   })
      //   .map((cat) => cat.name);
    }
    // console.log(categoryNames, "categoryName");
  }, [data, categories]);

  if (!data) return <div className="p-4">Loading...</div>;

  const {
    title,
    content,
    categoryIds,
    favourite,
    shares,
    media,
    publishedAt,
    userData,
  } = data;
  const tabs = [
    {
      key: "content",
      label: "Content",
      conent: <PostContent content={content} />,
    },
    {
      key: "comment",
      label: "Comment",
      conent: <Comment referrerId={id} />,
    },
  ];
  return (
    <>
      <div className="font-bold text-center text-lg xl:text-3xl text-chestnut-rose">
        Task Details
      </div>
      <div className="p-6">
        {/* Header Info Section */}
        <div className="bg-white rounded-xl shadow-md p-6 mb-6 flex flex-col md:flex-row items-center gap-6">
          {/* Task Image */}
          <div className="w-32 h-32">
            <Image
              src={media?.[0]?.url}
              width={128}
              height={128}
              alt="Task Media"
              classes="w-full h-full object-cover rounded-full border"
            />
          </div>

          {/* Info Grid */}
          <div className="flex-1 grid md:grid-cols-2 gap-6">
            {/* task Info */}
            <div>
              <h2 className="text-xl font-semibold">Task Tittle: {title}</h2>
              <p className="text-sm text-gray-600 mt-1">
                Published: {new Date(publishedAt).toLocaleDateString()}
              </p>
              {categoryNames.length > 0 && (
                <p className="text-sm text-gray-600 mt-1">
                  Categories: {categoryNames.join(", ")}
                </p>
              )}
              <div className="mt-2 text-sm">
                <span className="mr-4">❤️ Favourites: {favourite.length}</span>
                <span>🔗 Shares: {shares.length}</span>
              </div>
            </div>

            {/* User Info */}
            <div className="flex items-start gap-4">
              <div className="w-20 h-20">
                <Image
                  src={userData?.image?.url}
                  width={64}
                  height={64}
                  alt="User"
                  classes="w-16 h-16 rounded-full object-cover border"
                />
              </div>
              <div>
                <p className="font-medium">
                  {userData?.firstName} {userData?.lastName}
                </p>
                <p className="text-sm text-gray-500">{userData?.email}</p>
                <p className="text-sm text-gray-500">
                  Phone: {userData?.phone}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Tabs */}
        <MenuTabsWithLink
          classNames="mb-6"
          menu={tabs}
          isLinkEnable={false}
          setActiveIndex={setActiveTab}
        />

        {/* Content */}
        <div className="bg-white rounded-xl shadow-md p-6">
          {tabs[activeTab]?.conent}
        </div>
      </div>
    </>
  );
}
